export enum AssetStatus {
  READY = 'STATUS_READY',
  NOT_READY = 'STATUS_NOT_READY',
  OFFLINE = 'STATUS_OFFLINE',
  PARTIAL = 'STATUS_PARTIAL',
}

export interface Asset {
  name: string;
  host: string;
  type: string;
  version: string;
  businessSolution: string;
  status: AssetStatus;
  lastModifiedDate: string;
}

export interface AssetsStatusesEntry {
  status: AssetStatus;
  name: string;
}
